import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { SuscripcionBoletin } from 'src/app/models/obs/suscripcionBoletin';
import { SuscripcionService } from 'src/app/services/obs/suscripcion.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-admsuscription-list',
  templateUrl: './admsuscription-list.component.html',
  styleUrls: ['./admsuscription-list.component.scss']
})
export class AdmsuscriptionListComponent implements OnInit {

  // Propiedades del componente
  subscription: SuscripcionBoletin[] = [];
  msg: Message;
  selectedItem: any;
  id: number = 1;
  currentTab: any = null; // Para rastrear la pestaña actual
  isSubscribed: number = 1; // Controlamos la pestaña
  isAccepted: number = 1; // Controlamos la pestaña

  // Configuraciones relacionadas con el tipo de suscripciones
  requestIsSubscribed: any[] = [
    { id: 1, title: 'Subscripciones aceptadas', subscribed: 1, status: 1 },
    { id: 2, title: 'Subscripciones pendientes', subscribed: 1, status: 0 },
    { id: 3, title: 'Subscripciones rechazadas', subscribed: 0, status: 0 },
  ]

  constructor(
    private sbsS: SuscripcionService
  ) { }

  ngOnInit() {
    // Inicializa el componente llamando a changeTypeOfSubscription con parámetros iniciales
    this.changeTypeOfSubscription(this.id, this.isSubscribed, this.isAccepted);
  }

  // Método para obtener todas las suscripciones
  getAllSubscription(isSubscribed: number, isAccepted: number) {
    this.subscription = [];
    // Llama al servicio para obtener suscripciones
    this.sbsS.getAll4admin(isSubscribed, isAccepted).subscribe(
      res => {
        this.subscription = res['data'];
      },
      err => {
        this.msg = err;
      }
    )
  }

  // Método para cambiar el tipo de suscripción actual
  changeTypeOfSubscription(id: number, isSubscribed: number, isAccepted: number) {
    this.subscription = [];
    this.selectedItem = id;
    this.isSubscribed = isSubscribed;
    this.isAccepted = isAccepted;
    // Obtiene la pestaña actual
    this.currentTab = this.requestIsSubscribed.find(tab => tab.id === id);
    // Obtiene todas las suscripciones con los nuevos parámetros
    this.getAllSubscription(isSubscribed, isAccepted);
  }

  // Método para editar el estado de una suscripción
  editStatusSubscription(id: string, status: string, subscribed: string, email: string) {
    var text = " ";

    // Determina el texto del mensaje de confirmación según el estado
    if (status === '0') {
      text = "¿Está seguro de que desea rechazar la suscripción de:";
    } else if (status === '1') {
      text = "¿Está seguro de que desea aceptar la suscripción de:";
    }

    // Objeto con datos a enviar al servicio de actualización
    const data = { status: status, subscribed: subscribed };

    // Muestra un cuadro de confirmación
    if (confirm(text + ' ' + email)) {
      this.sbsS.updateSubscriptionStatus(id, data).subscribe(
        res => {
          // Actualiza la lista de suscripciones y la pestaña seleccionada
          this.getAllSubscription(this.isSubscribed, this.isAccepted);
          this.selectedItem = this.currentTab.id;
        },
        err => {
          console.log(err);
        }
      );
    }
  }


  generateCsvData(): string {
    // Encabezados CSV
    const headers = [
      'N°', 'Nombre', 'Apellido paterno', 'Apellido materno', 'Email', 'Estado'
    ];

    // Filas CSV
    const rows = this.subscription.map((s, i) => [
      i + 1,
      s.name,
      s.lastname,
      s.surname,
      s.email,

      (s.status === false && s.subscribed == true) ? 'PENDIENTE' :
        (s.status === true && s.subscribed === true) ? 'ACEPTADO' :
          (s.status === false && s.subscribed === false) ? 'RECHAZADO' : ''
    ]);

    // Unir encabezados y filas
    const csvData = [headers, ...rows];

    // Convertir a cadena CSV
    const csvContent = csvData.map(row => row.join(',')).join('\n');

    return csvContent;
  }

  downloadExcel() {
    // Encabezados de Excel
    const headers = [
      'N°', 'Nombre', 'Apellido paterno', 'Apellido materno', 'Email', 'Estado'
    ];

    // Datos para Excel
    const data = this.subscription.map((s, i) => [
      i + 1,
      s.name,
      s.lastname,
      s.surname,
      s.email,
      (s.status === false && s.subscribed == true) ? 'PENDIENTE' :
        (s.status === true && s.subscribed === true) ? 'ACEPTADO' :
          (s.status === false && s.subscribed === false) ? 'RECHAZADO' : ''
    ]);

    // Crear hoja de calculo en formato XLSX
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Crear libro de trabajo excel
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };

    // Convertir el libro de trabajo a un búfer de Excel
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Crear un Blob
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Crear un enlace de descarga
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'suscripciones.xlsx');

    // Agregar el enlace al cuerpo del documento
    document.body.appendChild(link);

    // Simular clic en el enlace para iniciar la descarga
    link.click();

    // Eliminar el enlace del cuerpo del documento
    document.body.removeChild(link);
  }


}
